<template lang="pug">
  div#app(:class="$style.app")
    el-container
      header-component(v-if="isAuthenticated")

    el-container(style="min-height: 100vh")
      router-view

    el-container
      footer-component(v-if="isAuthenticated")

</template>

<script>
  import { mapState } from 'vuex'

  import HeaderComponent from '@/masteradmin/components/HeaderComponent'
  import FooterComponent from '@/components/FooterComponent'

  export default {
    name: 'HVUMasterAdmin',

    components: {
      HeaderComponent,
      FooterComponent,
    },

    computed: {
      ...mapState({
        isAuthenticated: state => state.user.isAuthenticated,
      }),
    },
  }
</script>

<style>
  @import '../styles/app.css';
</style>

<style module>
  .app {
    min-height: 100%;
    background: linear-gradient(to bottom, var(--hvu-blue), var(--purple-blue));
  }
</style>



// WEBPACK FOOTER //
// client/masteradmin/App.vue